import script from "./ResumePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumePreview.vue?vue&type=script&setup=true&lang=js"

import "./ResumePreview.vue?vue&type=style&index=0&id=60d80920&lang=less"
import "./ResumePreview.vue?vue&type=style&index=1&id=60d80920&scoped=true&lang=less"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d80920"]])

export default __exports__